/**
 * 시세 수수료 정책 API.
 *
 * 값은 공용 서버(common-server)에 있고 관리자 서버가 중계한다. 거기가 고시가를
 * 계산하는 자리라 정책을 알아야 하고, 정책이 관리자 DB 에 있으면 공용 서버가
 * 남의 DB 를 들여다봐야 한다 — 관리는 여기서 하고 값은 저쪽에 둔다.
 *
 * 법인(tenant)별로 나눈다. 골드나라와 아우라가 지금은 같은 값을 넣지만 서로 다른
 * 법인이라 갈라질 수 있어야 한다.
 *
 * 권한: HQ(본사) 관리자 전용
 */
import api from './index'

const BASE = '/api/v1/metal-price/fee-policies'

/**
 * 지금 시세와 그 법인의 고시가. 기준시세 · 살 때 · 팔 때가 한 번에 온다.
 *
 * 금은 두 줄로 온다 - 국내(KRX, 원/g)와 해외(metals-api, USD/트로이온스)다.
 * 은·백금은 KRX 에 시장이 없어 해외 한 줄이고, 환율로 환산한 원/g 이 같이 온다.
 */
export function getLatestQuotes(tenant = 'GOLDNARA') {
  return api.get('/api/v1/metal-price/quotes', { params: { tenant } })
}

/** 법인·금속별 수수료 이력. 최신이 위로 온다. */
export function getFeePolicies(tenant = 'GOLDNARA') {
  return api.get(BASE, { params: { tenant } })
}

/**
 * 수수료를 새로 건다. **고치는 것이 아니라 새 버전을 쌓는다.**
 *
 * 앞 버전은 같은 시각에 닫힌다. 지난달 주문은 그때 값으로 가격이 매겨졌고
 * "왜 그 가격이었나" 를 계속 답할 수 있어야 하기 때문이다.
 *
 * @param {Object} body
 *   @param {string} body.tenant         GOLDNARA / AURA
 *   @param {string} body.metal          GOLD / SILVER / PLATINUM
 *   @param {string} body.baseFeeType    PCT / AMOUNT  — 칸마다 하나만 쓴다
 *   @param {number} body.baseFeeValue   기본 수수료. 양방향에 깔린다
 *   @param {string} body.buyFeeType
 *   @param {number} body.buyFeeValue    살 때. 기본에 **더해진다**
 *   @param {string} body.sellFeeType
 *   @param {number} body.sellFeeValue   팔 때
 *   @param {number} body.roundUnit      반올림 단위(원)
 *   @param {string} [body.effectiveFrom] ISO 시각. 비우면 지금부터
 *   @param {string} [body.memo]         왜 바꿨나 — 몇 달 뒤에 찾는 건 이쪽이다
 */
export function scheduleFeePolicy(body) {
  return api.post(BASE, body)
}

/** 끈다. 행은 남는다 — 지난 주문의 가격 근거라 지우지 않는다. */
export function deactivateFeePolicy(id) {
  return api.delete(`${BASE}/${id}`)
}
